import { ChatType } from "@common/enums/ChatType";

export const CHAT_TYPE_ROUTE_MAP: Record<string, ChatType> = {
    qiq: ChatType.Normal,
    wfdo: ChatType.QEC,
    esg: ChatType.ESG,
};
